import axiosInstance from "../../utils/axios";

const uploadImage = async (formData) => {
  try {
    const response = await axiosInstance.post("/product/uploadImage", formData);
    return response.data; // Assuming the API returns filePath or similar
  } catch (err) {
    console.error("Error uploading image:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const createProduct = async (values) => {
  try {
    // Log all files
    values.getAll("file[]").forEach((file) => {
      // console.log("Creating customer with file:", file);
    });

    const response = await axiosInstance.post("/pawn/product", values);
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    );
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const updateOrderPawn = async (values) => {
  try {
    const response = await axiosInstance.put(`/pawn/order-pawn/${values}`);
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    );
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const createSellOrder = async (values) => {
  // console.log("values", values);
  try {
    // console.log("Creating customer with values:", values); // Log the values
    const response = await axiosInstance.post(
      "/product/createSellOrder",
      values
    );
    // console.log("Customer creation response:", response.data); // Log the detailed response
    // console.log('',response.data);
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    ); // Log detailed error
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const createCustomer = async (values) => {
  try {
    // console.log("Creating customer with values:", values); // Log the values
    const response = await axiosInstance.post("/pawn/customer", values);
    // console.log("Customer creation response:", response.data); // Log the detailed response
    // console.log('',response.data);
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    ); // Log detailed error
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const createSellCustomer = async (values) => {
  try {
    // console.log("Creating customer with values:", values); // Log the values
    const response = await axiosInstance.post(
      "/product/createSellCustomer",
      values
    );
    // console.log("Customer creation response:", response.data); // Log the detailed response
    // console.log('',response.data);
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    ); // Log detailed error
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const updateProduct = async (values) => {
  try {
    // Log all files
    values.getAll("file[]").forEach((file) => {
      // console.log("Creating customer with file:", file);
    });

    const response = await axiosInstance.patch(
      "/product/updateProduct",
      values
    );
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    );
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const updateCustomer = async (values) => {
  try {
    // console.log("Creating customer with values:", values); // Log the values
    const response = await axiosInstance.patch(
      "/product/updateCustomer",
      values
    );
    // console.log("Customer creation response:", response.data); // Log the detailed response
    // console.log('',response.data);
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    ); // Log detailed error
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const updateStatusPawn = async (values) => {
  try {
    // console.log("Creating customer with values:", values); // Log the values
    const response = await axiosInstance.post("/pawn/order-pawn", values);
    // console.log("Customer creation response:", response.data); // Log the detailed response
    // console.log('',response.data);
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    ); // Log detailed error
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const updateRedeem = async (orderPawnId, values) => {
  // console.log("Sending FormData:", Array.from(values.entries()));
  // console.log("test", values.getAll());

  try {
    const response = await axiosInstance.patch(
      `/pawn/order-pawn-redeem/${orderPawnId}`,
      values,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
  } catch (err) {
    console.error(
      "Error updating redeem:",
      err.response ? err.response.data : err.message
    );
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const updateInterest = async (orderPawnId, values) => {
  // console.log("Sending FormData:", Array.from(values.entries()));
  // console.log("test", values.getAll());

  try {
    const response = await axiosInstance.patch(
      `/pawn/order-pawn-interest/${orderPawnId}`,
      values,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
  } catch (err) {
    console.error(
      "Error updating redeem:",
      err.response ? err.response.data : err.message
    );
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const createOrder = async (values) => {
  // console.log("values", values);
  try {
    // console.log("Creating customer with values:", values); // Log the values
    const response = await axiosInstance.post("/pawn/order", values);
    // console.log("Customer creation response:", response.data); // Log the detailed response
    // console.log('',response.data);
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    ); // Log detailed error
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const getOrder = async () => {
  try {
    const response = await axiosInstance.get("/pawn/order-pawn");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getPawnRedeem = async () => {
  try {
    const response = await axiosInstance.get("/pawn/order-pawn-redeem");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getOrderOverduePawn = async () => {
  try {
    const response = await axiosInstance.get("/pawn/order-pawn-forfeiture");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};
const changeToReturnOrder = async (values) => {
  try {
    const response = await axiosInstance.patch(
      "/product/changeToReturnOrder",
      values
    );
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const DeleteOrder = async (values) => {
  try {
    const response = await axiosInstance.delete(`/pawn/delete/${values}`);
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const ReuseOrder = async (values) => {
  try {
    const response = await axiosInstance.patch(`/pawn/reuseOrder/${values}`);
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getTrash = async () => {
  try {
    const response = await axiosInstance.get(`/pawn/trash`);
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getReadyOrders = async () => {
  try {
    const response = await axiosInstance.get("/product/getSellOrders");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getProduct = async () => {
  try {
    const response = await axiosInstance.get("/product/getProduct");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};
const getOneOrder = async () => {
  try {
    const response = await axiosInstance.get("/getOneOrder");
    // console.log("response.data", response.data);
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

//API
const connectUsbDevice = async (deviceDetails) => {
  try {
    console.log("Connecting with device details:", deviceDetails);

    // Sending device details to the server
    const response = await axiosInstance.post(
      "/pawn/connectedDevice",
      deviceDetails
    );

    return {
      isStatus: true,
      data: response.data,
      message: "Data received successfully",
    };
  } catch (err) {
    console.error(
      "Error connecting to USB device:",
      err.response ? err.response.data : err.message
    );
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const exportExcelOrderPawnForfeiture = async () => {
  try {
    return await axiosInstance.get("/pawn/export-excel-order-pawn-forfeiture", {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};
//  ไถ่ถอน
const exportExcelOrderPawnRedeem = async () => {
  try {
    return await axiosInstance.get("/pawn/export-excel-order-pawn-redeem", {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const exportExcelOrderPawn = async () => {
  try {
    return await axiosInstance.get("/pawn/export-excel-order-pawn", {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getPrintPdfPawnOrder = async (order_id) => {
  try {
    return await axiosInstance.get(`/pawn/print-pdf-pawn-order/${order_id}`, {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getPrintPdfInterestOrder = async (order_id) => {
  try {
    return await axiosInstance.get(
      `/pawn/print-pdf-interest-order/${order_id}`,
      {
        responseType: "blob",
      }
    );
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getPrintPdfRedeemOrder = async (order_id) => {
  try {
    return await axiosInstance.get(`/pawn/print-pdf-redeem-order/${order_id}`, {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const ProductAPI = {
  connectUsbDevice,
  uploadImage,
  createProduct,
  createCustomer,
  updateProduct,
  updateCustomer,
  createOrder,
  getOrder,
  getOneOrder,
  getProduct,
  getReadyOrders,
  createSellOrder,
  createSellCustomer,
  updateStatusPawn,
  updateOrderPawn,
  getOrderOverduePawn,
  updateRedeem,
  getPawnRedeem,
  updateInterest,
  changeToReturnOrder,
  DeleteOrder,
  ReuseOrder,
  getTrash,

  // Export Excel
  exportExcelOrderPawnForfeiture,
  exportExcelOrderPawnRedeem,
  exportExcelOrderPawn,

  // Print PDF
  getPrintPdfPawnOrder,
  getPrintPdfInterestOrder,
  getPrintPdfRedeemOrder,
};

export default ProductAPI;
